function Icon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      className={className}
    >
      <g clipPath="url(#clip0_374_17)">
        <path
          fill="#3F434A"
          d="M8 0a8 8 0 110 16A8 8 0 018 0zm0 2.4a5.6 5.6 0 100 11.2A5.6 5.6 0 008 2.4z"
        ></path>
        <path
          fill="#13CB75"
          d="M13.656 13.663A8.004 8.004 0 002.337 2.344a1.2 1.2 0 001.698 1.698 5.603 5.603 0 117.923 7.923 1.2 1.2 0 001.698 1.698z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_374_17">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
